/**
 * @file Title
 * @author zhangyou
 */
import React from 'react'

export default ({ title, children }) => (
  <div className="tnt-querylistscene-title">
    <span>{title}</span>
    <span>{children}</span>
  </div>
)
